
define('text!templates/components/reseller_role/reseller_role.html',[],function () { return '<td data-cell="name">\n    <a href="/personal-roles/<%= id %>"><%= role_name %> </a>\n</td>\n\n\n';});

